import NewFeatureDialog from './NewFeatureDialog';

export default NewFeatureDialog;
